export const curStateAccount = (state) => state.account;
export const curStateMiniGame = (state) => state.miniGame;
export const curStateHome = (state) => state.home;
export const curStateEventThingyan2025 = (state) => state.eventThingyan2025;
